import React, { useEffect, useState } from 'react'
import { api } from '../../../../../utils'
import { MODALITA_SPEDIZIONE, PROFILOAZIENDA } from '../../../../../utils/endpoint'
import Button from '../../../../atoms/Button/Button'
import FormField from '../../../../atoms/FormField/FormField'
import FormRadio from '../../../../atoms/FormRadio/FormRadio'
import LoadingSvg from '../../../../atoms/Loading/Loading'
import { trackingCheckoutStart } from '../../../../../utils/gtm'
import useTrans from '../../../../../hooks/useTrans'
import { useRouter } from 'next/router'
import * as Sentry from '@sentry/browser'

const ModalitaSpedizione = ({
  setStep,
  step,
  props,
  isMerceNeutra,
  service_gift,
  carrello_main,
}) => {
  const [Loading, setLoading] = useState(false)
  const [modalitaSpedizione, setModalitaSpedizione] = useState([])
  const [ritiro, setRitiro] = useState(props.values.tipo_spedizione === 'Ritiro' ? true : false)
  const [idSpedizione, setIdSpedizione] = useState(
    props.values.tipo_spedizione_id ? props.values.tipo_spedizione_id : null
  )
  const [selectedOption, setSelectedOption] = useState(
    props.values.tipo_spedizione ? props.values.tipo_spedizione : null
  )
  const t = useTrans()
  const router = useRouter()

  useEffect(() => {
    setLoading(true)
    api
      .get(MODALITA_SPEDIZIONE, {
        params: {
          lang: router.locale,
        },
      })
      .then((res) => {
        setModalitaSpedizione(res.data)
        // ! da Ottimizzare Over-E
        !service_gift?.attivo &&
          api.get(PROFILOAZIENDA).then((profilo) => {
            if (!props.values.tipo_spedizione) {
              // ! Nel caso di modifica non sarà inserito il valore "preselezionato"
              if (profilo.data?.indirizzo_sede) {
                const profilo_modalita_id = profilo?.data?.indirizzo_sede?.modalita_spedizione_id
                if (profilo_modalita_id !== null) {
                  const result = res.data.filter((tipo) => tipo.id === profilo_modalita_id)
                  result.length > 0 &&
                    (setIdSpedizione(result[0].id),
                    setRitiro(result[0].modalita === 'Ritiro' ? true : false),
                    setSelectedOption(result[0].modalita))
                }
              } else {
                let spedizione = res.data.filter((modalita) => modalita.codice === '002')
                spedizione.length > 0 &&
                  (setIdSpedizione(spedizione[0].id),
                  setRitiro(spedizione[0].modalita === 'Ritiro' ? true : false),
                  setSelectedOption(spedizione[0].modalita))
              }
            }
          })
        setLoading(false)
      })
      .catch((err) => {
        setLoading(false)
        console.log(err?.message)
        Sentry.captureException(err)
      })
  }, [])

  useEffect(() => {
    selectedOption && props.setFieldValue('tipo_spedizione', selectedOption)
    idSpedizione && props.setFieldValue('tipo_spedizione_id', idSpedizione)
  }, [selectedOption, idSpedizione])

  return Loading ? (
    <LoadingSvg />
  ) : (
    <>
      <FormField className="checkout__formfield">
        {modalitaSpedizione &&
          modalitaSpedizione.map((modalita) => (
            <div
              className={
                'checkout__option' +
                (idSpedizione === modalita.id ? ' checkout__option--selected' : '')
              }
              key={modalita.id}
            >
              <FormRadio
                label={modalita.descrizione}
                key={modalita.id}
                checked={idSpedizione === modalita.id ? true : false}
                onClick={() => {
                  setIdSpedizione(modalita.id)
                  setRitiro(modalita.modalita === 'Ritiro' ? true : false)
                  setSelectedOption(modalita.modalita)
                }}
              />
            </div>
          ))}
      </FormField>

      <Button
        disabled={selectedOption ? false : true}
        label={t('Conferma Spedizione')}
        variant="primary"
        size="medium"
        onClick={() => {
          setStep(ritiro === false ? step + 1 : isMerceNeutra ? 2 : 2)
          trackingCheckoutStart(carrello_main)
        }}
      />
    </>
  )
}

export default ModalitaSpedizione
